(function(){
if(window.__vxcesta)return;window.__vxcesta=1;
var K='vxCesta_',ATIVA='vxCestaAtiva',ocupado=false;
function perfil(){try{return localStorage.getItem('vxPerfil')==='usd'?'usd':'brl'}catch(e){return 'brl'}}
function le(p){try{return JSON.parse(localStorage.getItem(K+p)||'[]')}catch(e){return []}}
function grava(p,v){try{localStorage.setItem(K+p,JSON.stringify(v||[]))}catch(e){}}
function ativa(){try{return localStorage.getItem(ATIVA)||''}catch(e){return ''}}
function marca(p){try{localStorage.setItem(ATIVA,p)}catch(e){}}
function trava(on){
 ocupado=on;
 document.querySelectorAll('[data-vxperfil-b]').forEach(function(b){b.disabled=on;b.style.opacity=on?'.55':'';b.style.pointerEvents=on?'none':''});
 document.documentElement.toggleAttribute('data-cesta-troca',on);
}
function json(u,o){return fetch(u,o).then(function(r){return r.json()})}
function troca(de,para,recarrega){
 if(ocupado)return Promise.resolve();
 trava(true);
 return json('/cart.js')
  .then(function(c){
   grava(de,(c.items||[]).map(function(i){return {id:i.variant_id,quantity:i.quantity,properties:i.properties||{}}}));
   if(!(c.items||[]).length)return null;
   return fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}});
  })
  .then(function(){
   var itens=le(para);
   if(!itens.length)return null;
   return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:itens})});
  })
  .then(function(){
   marca(para);
   if(recarrega===false)return;
   if(window.vxCarRecarrega)window.vxCarRecarrega(false);
   else if(/^\/(cart|checkout)/.test(location.pathname))location.reload();
  })
  .catch(function(){})
  .then(function(){trava(false)});
}
document.addEventListener('vxperfil',function(e){
 var para=e.detail&&e.detail.perfil==='usd'?'usd':'brl';
 var de=para==='usd'?'brl':'usd';
 troca(de,para,true);
});
function reconcilia(){
 var p=perfil(),a=ativa();
 if(!a){marca(p);return}
 if(a===p)return;
 troca(a,p,false);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',reconcilia);else reconcilia();
window.vxCesta={perfil:perfil,le:le,troca:troca};
})();
